var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconSquareCheck = function SvgIconSquareCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 6.75,
    r: 6.75,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "#04A985",
    rx: 2.571
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.808 6.655c-.235-.233-.623-.243-.868-.02s-.255.592-.02.825l1.364 1.36a.63.63 0 0 0 .442.18h.002a.625.625 0 0 0 .44-.178l4.16-4.083a.564.564 0 0 0-.015-.825.637.637 0 0 0-.868.014L5.731 7.575l-.923-.92z"
  })))));
};

export default SvgIconSquareCheck;